import { Group, Stack, Text } from "@mantine/core"
import { Select } from "@tfg/ui"
import { Trans, useTranslation } from "react-i18next"

import { ProgressBox } from "~/pages/Brand/Home/components/ProgressBox.tsx"

type Props = {
  certificateTypes: string[]
  setCertificateType: (value: string | null) => void
  countValidatedCertificate: number
  countCollectedCertificate: number
  validatedPercent: number
  collectedPercent: number
}

export function DocumentsKPIView({
  certificateTypes,
  setCertificateType,
  countValidatedCertificate,
  countCollectedCertificate,
  validatedPercent,
  collectedPercent,
}: Props) {
  const { t } = useTranslation("home")

  return (
    <Stack>
      <Group>
        <Select
          size="xs"
          clearable
          onChange={setCertificateType}
          data={certificateTypes}
          placeholder={t("documents.certificateType")}
        />
      </Group>
      <Stack bg="white" px="md" py="md">
        <ProgressBox
          sections={[
            {
              color: "green",
              text: countValidatedCertificate.toString(),
              width: validatedPercent,
              label: t("documents.verified"),
            },
            {
              color: "gray.4",
              text: countCollectedCertificate.toString(),
              width: collectedPercent,
              label: t("documents.pending"),
            },
          ]}
          total={countCollectedCertificate + countValidatedCertificate}
          helpHoverText={
            validatedPercent === 100
              ? t("documents.totalTextCompleted")
              : t("documents.totalText")
          }
          helpHoverRedirectTo="/documents"
        />
        <Text fz="md">
          <Trans ns="home" i18nKey="documents.complete">
            <strong>
              {{
                percent: Number.isNaN(validatedPercent) ? 0 : validatedPercent,
              }}
            </strong>
          </Trans>
        </Text>
      </Stack>
    </Stack>
  )
}
